import { mainApi } from '@shared/api'

export const { getMealsForDate } = mainApi
